export default __webpack_public_path__ + "static/media/Baltimore Life.73b049df.svg";